import React, { Component } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';

class ConfirmSave extends Component {

    constructor(){
        super();
        this.state = {
            isLoading: false
        }
    }

    onConfirm = () => {
        this.setState({ isLoading: true });
        this.props.onConfirm(this.finishLoading);
    }

    finishLoading = () => {
        this.setState({ isLoading: false });
    }

    render(){
        const { isLoading } = this.state;
        const { open, onCancel, cancelButton, confirmButton, content, iconName, iconColor, iconSize, header, modalSize } = this.props;

        return (
            <Modal open={open} size={modalSize} >
                <Modal.Header>{header}</Modal.Header>
                <Modal.Content image scrolling>
                    <Icon name={iconName} color={iconColor} size={iconSize} /> 
                    <Modal.Description>
                        {content}
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button icon='remove' content={cancelButton} onClick={onCancel} />
                    <Button positive loading={isLoading} icon='checkmark' content={confirmButton} onClick={this.onConfirm} />
                </Modal.Actions>
            </Modal>
        )
    }
}

export default ConfirmSave;


// WEBPACK FOOTER //
// ./src/components/ConfirmSave.js